var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ElementRefItems.ts";
import * as t from 'io-ts';
import { BimReference } from './BimReference';
export var ElementRefItems;

(function (_ElementRefItems) {
  var io = _ElementRefItems.io = t.recursion('ElementRefItems', function () {
    return t.type({
      items: t.array(BimReference.Element.io)
    }, 'ElementRefItems');
  });
})(ElementRefItems || (ElementRefItems = {}));